// Header item  is set up fixed count for solving responsiveness issues for RN
export const HEADER_ITEM_COUNT = 6
